// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"9a912375","169":"9273cbe4","351":"271405d3","378":"7d8e9f1c","530":"c92b0e2d","780":"7cca32f5","841":"8057c832","842":"1cac5f23","849":"e244b5df"}[chunkId] + ".chunk.js";
};